import axios from 'axios'
import load from "../LOAD.js";

const instance = axios.create({
  baseURL: load.getUrlApi(),

})

export default instance